import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { noDataFound, noDataIBA } from "../../../../CommonMethhods/CommonMethods";

const LeaderBoard = ({ data = [] }) => {
    // if (!data.length) return null;
     if (!data || data.length === 0) {
        return noDataIBA();
    }

    const sortedData = [...data].sort((a, b) => a.rank - b.rank);

    const formattedData = sortedData.map((item) => ({
        name: item?.agentName,
        y: Number(item?.accountsOpened),
        rank: item?.rank
    }));

    const topThree = formattedData
        .slice(0, 3)
        .sort((a, b) => b.rank - a.rank);

    const nextTwo = formattedData.slice(3);

    // 🔹 TOP 3 (Vertical)
    const columnOptions = {
        chart: {
            type: "column",
            backgroundColor: "transparent",
            height: 220,
            spacingTop: 0,
            spacingBottom: 0,
            marginBottom: 0,
            style: {
            fontFamily: "Rubik"
        }
        },
        title: { text: null },
        tooltip: { enabled: false },
        xAxis: {
            categories: topThree.map((item) => item.name),
            labels: { enabled: false },
            lineWidth: 0,
            tickLength: 0
        },
        yAxis: {
            visible: false,
            min: 0,
            max: Math.max(...topThree.map(item => item.y)) * 1.4 // 👈 adds headroom
        },
        legend: { enabled: false },
        credits: { enabled: false },
        plotOptions: {
            column: {
                pointWidth: 70,
                borderRadius: 12,
                states: {
                    hover: {
                        enabled: false
                    }
                },

            }
        },
        series: [
            {
                data: topThree,
                color: "#F4C430",
                dataLabels: [
                    {
                        enabled: true,
                        useHTML: true,
                        align: "center",
                        verticalAlign: "top",
                        y: -70,
                        inside: false,
                        crop: false,
                        overflow: "allow",
                        formatter: function () {
                            const name = this.point.name;
                            const initials = name
                                .split(" ")
                                .map(word => word[0])
                                .join("")
                                .toUpperCase();

                            return `
                                <div style="
                                width:36px;
                                height:36px;
                                border-radius:50%;
                                background:#fff;
                                border: 2px solid #F4C430;
                                display:flex;
                                align-items:center;
                                justify-content:center;
                                font-weight:500;
                                margin:0 auto;
                                fontSize: 14px;
                                ">
                                ${initials}
                                </div>
                            `;
                        }
                    },

                    {
                        enabled: true,
                        useHTML: true,
                        align: "center",
                        verticalAlign: "top",
                        y: -30,
                        inside: false,
                        crop: false,
                        overflow: "allow",
                        style: {
                            color: "#000",
                            fontSize: "14px",
                            fontWeight: "500",
                            textOutline: "none",
                            
                        },
                        formatter: function () {
                            return `
                            
                            ${this.point.name}
                            
                        `;
                        }
                    },

                    {
                        enabled: true,
                        align: "center",
                        verticalAlign: "top",
                        inside: true,
                        y: 5,
                        style: {
                            color: "#FFFFFF",
                            fontSize: "22px",
                            fontWeight: "500",
                            textOutline: "none"
                        },
                        formatter: function () {
                            return this.point.rank < 10
                                ? "0" + this.point.rank
                                : this.point.rank;
                        }
                    },

                    // 🔹 Value (inside bottom)
                    {
                        enabled: true,
                        align: "center",
                        verticalAlign: "bottom",
                        inside: true,
                        y: -5,
                        style: {
                            color: "#000000",
                            fontSize: "18px",
                            fontWeight: "500",
                            textOutline: "none"
                        },
                        formatter: function () {
                            return this.y;
                        }
                    }
                ]
            }
        ]
    };

    const barOptions = {
    chart: {
        type: "bar",
        backgroundColor: "transparent",
        height: nextTwo.length * 90,
            spacingTop: 0,
            spacingBottom: 0,
            marginBottom: 0,
        style: {
    fontFamily: "Rubik"
  }
    },
    title: { text: null },
    tooltip: { enabled: false },
    xAxis: {
        categories: nextTwo.map((item) => item.name),
        visible: false
    },
    yAxis: {
        visible: false,
        min: 0,
        max: Math.max(...nextTwo.map(item => item.y)) * 1
    },
    legend: { enabled: false },
    credits: { enabled: false },

    plotOptions: {
        bar: {
        borderRadius: 10,
        pointHeight: 30,
        states: {
            hover: { enabled: false }
        },
        pointPadding: 0.10,
         groupPadding: 0.10
        }
    },

    series: [
        {
        data: nextTwo,
        color: "#F1F6FF",
        dataLabels: [
            {
            enabled: true,
            useHTML: true,
            align: "left",
            inside: true,
            x: 12,
            formatter: function () {
                const name = this.point.name;
                const initials = name
                .split(" ")
                .map(word => word[0])
                .join("")
                .toUpperCase();

                const rank =
                this.point.rank < 10
                    ? "0" + this.point.rank
                    : this.point.rank;

                return `
                <div style="
                    display:flex;
                    align-items:center;
                    gap:15px;
                    font-size:22px;
                    font-weight:500;
                    font-family: "Rubik";
                ">
                    <span style="
                    margin-right:25px;
                    ">${rank}</span>

                    <div style="
                    width:28px;
                    height:28px;
                    border-radius:50%;
                    background:#ffffff;
                    border:1px solid #000;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    font-size:14px;
                    margin-right:12px;
                    ">
                    ${initials}
                    </div>

                    <span style="font-weight:500;font-size:14px">${name}</span>
                </div>
                `;
            }
            },

            // 🔹 RIGHT SIDE (Accounts Opened)
            {
            enabled: true,
            align: "right",
            inside: true,
            x: -10,
            style: {
                fontWeight: "500",
                fontSize: "18px",
                textOutline: "none",
                color: "#1C74D0"
            },
            formatter: function () {
                return this.y;
            }
            }
        ]
        }
    ]
    };    

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={columnOptions} />

            {nextTwo.length > 0 && (
                <HighchartsReact highcharts={Highcharts} options={barOptions} />
            )}
        </>
    );
};

export default LeaderBoard;